/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb145Inputs */

const en__field_enum_pbs_fb145 = /** @type {(inputs: _Field_Enum_Pbs_Fb145Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 14 Faculty of Biochemistry, Chemistry and Pharmacy`)
};

const de__field_enum_pbs_fb145 = /** @type {(inputs: _Field_Enum_Pbs_Fb145Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 14 Biochemie, Chemie und Pharmazie`)
};

/**
* | output |
* | --- |
* | "F 14 Faculty of Biochemistry, Chemistry and Pharmacy" |
*
* @param {_Field_Enum_Pbs_Fb145Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb145 = /** @type {((inputs?: _Field_Enum_Pbs_Fb145Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb145Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb145(inputs)
	return de__field_enum_pbs_fb145(inputs)
});
export { _field_enum_pbs_fb145 as "_field_enum_PBS_FB14" }